import { render, staticRenderFns } from "./ListPackageRoomPlan.vue?vue&type=template&id=253e93de"
import script from "./ListPackageRoomPlan.vue?vue&type=script&lang=js"
export * from "./ListPackageRoomPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports